import { getEditorString, getPointBefore, getRange, deleteBackward } from '@udecode/plate-common';

export const withTrigger = (editor, { options, type }) => {
  const { insertText } = editor;
  const { createSmartInput, trigger, triggerPreviousCharPattern } = options;
  const matchesTrigger = (text) => {
    if (trigger instanceof RegExp) {
      return trigger.test(text);
    }

    if (Array.isArray(trigger)) {
      return trigger.includes(text);
    }

    return text === trigger;
  };

  editor.insertText = (text) => {
    if (!editor.selection || !matchesTrigger(text)) {
      return insertText(text);
    }

    const previousChar = getEditorString(
      editor,
      getRange(editor, editor.selection, getPointBefore(editor, editor.selection)),
    );

    const matchesPreviousCharPattern =
      triggerPreviousCharPattern?.test(previousChar);

    if (matchesPreviousCharPattern) {
      deleteBackward(editor);
      const inputNode = createSmartInput
        ? createSmartInput(text)
        : { children: [{ text: '' }], type };
      return editor.insertNode(inputNode);
    }

    return insertText(text);

  };

  return editor;
};
